import { Component, Injector } from '@angular/core';
import { CustomInjector, DateUtilities, RouterHelperService, TranslationService } from '@evorait/pace-core';
import moment from 'moment';

@Component({
    selector: 'pace-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    public constructor(
        private readonly injector: Injector,
        private readonly routerHelper: RouterHelperService,
        private readonly translationService: TranslationService,
    ) {
        const langKey = this.translationService.getLanguageKey();
        // find the date format of user's operating system to maintain same format through out the application
        const dateFormatter = new Intl.DateTimeFormat(); // this is a javascript builtin api used to get the date/time format of the user's OS
        const options = dateFormatter.resolvedOptions();
        DateUtilities.setLocale(options.locale || 'en-US');

        // If the language of the device is not defined in the mapped locale set then by default locale 'en' will be set.
        moment.locale(langKey);

        // Make injector statically available for access in domain models, where angular does not provide a DI mechanism
        CustomInjector.setInjector(this.injector);

        this.routerHelper.subscribeToEvents();
    }
}
